<template>
  <div class="blog">
    <div class="container">
      <v-breadcrumb :title="collection.title" route="blogs-show" />
      <p class="blog__title">{{ collection.title }}</p>
      <div class="blog__content">
        <template v-if="list.length > 0">
          <template
            v-for="(item, index) in list"
          >
            <v-blog-card :key="item.id" :index="index" :data="item" />
          </template>
        </template>
        <div v-else class="blog__no-content">
          <h3>{{ $t('blog.empty_collections') }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlogCard from "./components/Card.vue";
import Breadcrumb from "@/js/components/Breadcrumb.vue";

export default {
  name: "Blog",
  components: {
    [Breadcrumb.name]: Breadcrumb,
    [BlogCard.name]: BlogCard,
  },
  props: {
    list: {
      type: Array,
      require: true,
    },
    collection: {
      type: Object,
      default: {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/mobile.scss";

.blog {
  padding: 40px 0;
  &__title {
    font-size: 30px;
    font-weight: bold;
    color: #222a40;
    margin-top: 28px;
  }
  &__content {
    margin-top: 20px;
  }
  &__no-content {
    text-align: center;
    color: #555;
    text-transform: uppercase;
    padding-top: 50px;
  }

  @media only screen and (max-width: 767px) {
    padding: px(25) 0;
    &__title {
      font-size: px(18);
      margin-top: 0;
    }
  }
}
</style>
